export default "__VITE_ASSET__DoxPcqbX__"